import { Client, IMessage } from '@stomp/stompjs';
import type { DayProcessProgressEvent } from './DayEndService';

export const createDayProcessClient = async (onMessage: (event: DayProcessProgressEvent) => void) => {
    const { default: SockJS } = await import('sockjs-client');
    const client = new Client({
        webSocketFactory: () => new SockJS('/ws/notifications'),
        reconnectDelay: 5000,
        onConnect: () => {
            client.subscribe('/topic/day-process/progress', (message: IMessage) => {
                onMessage(JSON.parse(message.body) as DayProcessProgressEvent);
            });
        },
    });

    client.activate();
    return client;
};
